export class CompanyStrongoSetting {
    public id: number | null;
    public company_id: number | null;
    public is_client: number;
    public is_validated: number;
    public is_lead: number;
    public client_type: number | null;
    public min_shipments: number;
    public max_shipments: number;
    public franchisor_id: string | null;
    public franchisor_location_id: string | null;
    public delivery_sms: number;
    public sms_name: string;
    public confirmation_codes_active: number;
    public awb_print_count: number;
    public several_print_count: number;
    public can_print_a6: number;
    public mixed_group_print: number;
    public print_separator: string;
    public show_customer_reference_barcode_on_print: string | null;
    public hide_sender_address: number;
    public label_text: string | null;
    public default_content: string | null;
    public group_skip_content: number;
    public courier: number;
    public is_occasional: number;
    public fixed_sender_address: number;
    public can_view_price: number;
    public has_pickups: number;
    public initial_pickup_status: string;
    public awb_series: number;
    public preprinted_awb_series: number;
    public retur_awb_series: number;
    public hub: number;
    public skip_courier_comission: number;
    public skip_km_on_courier_comission: number;
    public awb_event_handler: string | null;
    public initial_api_status: string;
    public initial_import_status: string;
    public block_reweights: number;
    public reweigh_percentage: number;
    public supplies_discount_percent: number;
    public mandatory_hub: string | null;
    public late_retur_criteria: string | null;
    public switch_with_retur: number;
    public replacement_swap: number;
    public expeditions_can_be_paid_by_card: number;
    public remove_f_number_from_all_awbs: number;
    public static_batch_returs: number;
    public do_not_invoice: number;
    public max_address_character_size: number;
    public show_test_watermark_on_label: number;
    public reference_on_return_label: number;
    public customer_reference_prefix: string | null;
    public retur_flow_type: string;
    public show_reweight_events_in_history: string;
    public hide_phone_at_print: number;
    public hide_phone_at_print_for_franchisors: string | null;
    public anonimize_awb_details_after_days: number;
    public volumetric_weight_constant: number;
    public custom_annex_template: string | null;
    public custom_cod_annex_template: string | null;
    public custom_cod_annex_starting_no: number;
    public weight_price_rounding: string | null;
    public ramburs_type: string;
    public force_ramburs_type: number;
    public force_cod_only: number;
    public allowed_ramburs_types: string;
    public block_client_deconts: number;
    public hide_ramburs_receipt: number;
    public date_on_cod_receipt: number;
    public tax_ramburs_on_returned: number;
    public email_decont: string | null;
    public cod_report_enabled: number;
    public cod_report_email: string | null;
    public substract_price_from_client_decont: number;
    public cod_decont_delay_days: number;
    public auto_add_existing_invoices: number;
    public default_payer: string | null;
    public cash_invoice_client: number;
    public invoice_description: string | null;
    public strongo_currency: string | null;
    public tva_percent: number | null;
    public invoice_reminders: number;
    public penalty: number;
    public cash_only: number;
    public hide_sender_payer: number;
    public auto_invoice: number;
    public invoice_delay_days: number;
    public invoice_group: string | null;
    public invoice_grouped_by_address: number;
    public can_pay_to_courier: number;
    public max_pay_to_courier: number;
    public invoice_uncollected_expeditions: string | null;
    public invoice_active_and_notified: string | null;
    public invoice_exception_shipments: string | null;
    public skip_auto_lock: number;
    public days_until_blocking: number;
    public min_priced_insurance: number;
    public discount_percent: number;
    public use_credits: number;
    public credit_price: number;
    public price_only_destination_km: number;
    public ignore_volumetric_weight: number;
    public kg_included_per_retur: number;
    public strongo_contact: string | null;
    public support_email: string | null;
    public delivery_email: string | null;
    public use_cod_information: number;
    public cod_name: string | null;
    public cod_phone: string | null;
    public cod_address: string | null;
    public cod_city: string | null;
    public cod_county: string | null;
    public cod_zipcode: string | null;
    public cod_country: number | null;
    public cod_regcom: string | null;
    public cod_cui: string | null;
    public from_contact: string | null;
    public from_address: string | null;
    public from_sector: string | null;
    public from_zipcode: string | null;
    public from_country: number | null;
    public from_county: string | null;
    public from_city: string | null;
    public from_phone: string | null;
    public fixed_cod_retur_address: number;
    public cod_retur_address: string | null;
    public cod_retur_zipcode: string | null;
    public cod_retur_city: string | null;
    public cod_retur_county: string | null;
    public cod_retur_country: number | null;
    public cod_retur_phone: string | null;
    public fixed_retur_address: number;
    public retur_address: string | null;
    public retur_zipcode: string | null;
    public retur_city: string | null;
    public retur_county: string | null;
    public retur_country: number | null;
    public retur_phone: string | null;

    constructor(data: CompanyStrongoSettingData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.company_id = null;
            this.is_client = 1;
            this.is_validated = 1;
            this.is_lead = 0;
            this.client_type = null;
            this.min_shipments = 0;
            this.max_shipments = 0;
            this.franchisor_id = "";
            this.franchisor_location_id = "";
            this.delivery_sms = 1;
            this.sms_name = "STRONGO";
            this.confirmation_codes_active = 0;
            this.awb_print_count = 0;
            this.several_print_count = 1;
            this.can_print_a6 = 1;
            this.mixed_group_print = 0;
            this.print_separator = "0";
            this.show_customer_reference_barcode_on_print = "";
            this.hide_sender_address = 1;
            this.label_text = "";
            this.default_content = "";
            this.group_skip_content = 0;
            this.courier = 0;
            this.is_occasional = 0;
            this.fixed_sender_address = 0;
            this.can_view_price = 0;
            this.has_pickups = 0;
            this.initial_pickup_status = "requested";
            this.awb_series = 2841;
            this.preprinted_awb_series = 2841;
            this.retur_awb_series = 2841;
            this.hub = 0;
            this.skip_courier_comission = 0;
            this.skip_km_on_courier_comission = 0;
            this.awb_event_handler = "";
            this.initial_api_status = "neridicat";
            this.initial_import_status = "neridicat";
            this.block_reweights = 0;
            this.reweigh_percentage = 0;
            this.supplies_discount_percent = 0;
            this.mandatory_hub = "false";
            this.late_retur_criteria = "";
            this.switch_with_retur = 0;
            this.replacement_swap = 0;
            this.expeditions_can_be_paid_by_card = 1;
            this.remove_f_number_from_all_awbs = 0;
            this.static_batch_returs = 0;
            this.do_not_invoice = 0;
            this.max_address_character_size = 0;
            this.show_test_watermark_on_label = 0;
            this.reference_on_return_label = 1;
            this.customer_reference_prefix = "";
            this.retur_flow_type = "bulk";
            this.show_reweight_events_in_history = "from_settings";
            this.hide_phone_at_print = 1;
            this.hide_phone_at_print_for_franchisors = "";
            this.anonimize_awb_details_after_days = 15;
            this.volumetric_weight_constant = 0;
            this.custom_annex_template = "";
            this.custom_cod_annex_template = "";
            this.custom_cod_annex_starting_no = 0;
            this.weight_price_rounding = "";
            this.ramburs_type = "cont";
            this.force_ramburs_type = 1;
            this.force_cod_only = 0;
            this.allowed_ramburs_types = "";
            this.block_client_deconts = 0;
            this.hide_ramburs_receipt = 0;
            this.date_on_cod_receipt = 1;
            this.tax_ramburs_on_returned = 0;
            this.email_decont = "";
            this.cod_report_enabled = 0;
            this.cod_report_email = "";
            this.substract_price_from_client_decont = 0;
            this.cod_decont_delay_days = 0;
            this.auto_add_existing_invoices = 0;
            this.default_payer = "client";
            this.cash_invoice_client = 0;
            this.invoice_description = "";
            this.strongo_currency = "";
            this.tva_percent = null;
            this.invoice_reminders = 0;
            this.penalty = 0;
            this.cash_only = 0;
            this.hide_sender_payer = 0;
            this.auto_invoice = 0;
            this.invoice_delay_days = 0;
            this.invoice_group = null;
            this.invoice_grouped_by_address = 0;
            this.can_pay_to_courier = 0;
            this.max_pay_to_courier = 0;
            this.invoice_uncollected_expeditions = null;
            this.invoice_active_and_notified = null;
            this.invoice_exception_shipments = null;
            this.skip_auto_lock = 0;
            this.days_until_blocking = 0;
            this.min_priced_insurance = 0;
            this.discount_percent = 0;
            this.use_credits = 0;
            this.credit_price = 0;
            this.price_only_destination_km = 0;
            this.ignore_volumetric_weight = 0;
            this.kg_included_per_retur = 0;
            this.strongo_contact = "";
            this.support_email = "";
            this.delivery_email = "";
            this.use_cod_information = 0;
            this.cod_name = "";
            this.cod_phone = "";
            this.cod_address = "";
            this.cod_city = "";
            this.cod_county = "";
            this.cod_zipcode = "";
            this.cod_country = 182;
            this.cod_regcom = "";
            this.cod_cui = "";
            this.from_contact = "";
            this.from_address = "";
            this.from_sector = "";
            this.from_zipcode = "";
            this.from_country = 182;
            this.from_county = "";
            this.from_city = "";
            this.from_phone = "";
            this.fixed_cod_retur_address = 0;
            this.cod_retur_address = "";
            this.cod_retur_zipcode = "";
            this.cod_retur_city = "";
            this.cod_retur_county = "";
            this.cod_retur_country = 182;
            this.cod_retur_phone = "";
            this.fixed_retur_address = 0;
            this.retur_address = "";
            this.retur_zipcode = "";
            this.retur_city = "";
            this.retur_county = "";
            this.retur_country = 182;
            this.retur_phone = "";
        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.is_client = data.is_client;
            this.is_validated = data.is_validated;
            this.is_lead = data.is_lead;
            this.client_type = data.client_type;
            this.min_shipments = data.min_shipments;
            this.max_shipments = data.max_shipments;
            this.franchisor_id = data.franchisor_id;
            this.franchisor_location_id = data.franchisor_location_id;
            this.delivery_sms = data.delivery_sms;
            this.sms_name = data.sms_name;
            this.confirmation_codes_active = data.confirmation_codes_active;
            this.awb_print_count = data.awb_print_count;
            this.several_print_count = data.several_print_count;
            this.can_print_a6 = data.can_print_a6;
            this.mixed_group_print = data.mixed_group_print;
            this.print_separator = data.print_separator;
            this.show_customer_reference_barcode_on_print = data.show_customer_reference_barcode_on_print;
            this.hide_sender_address = data.hide_sender_address;
            this.label_text = data.label_text;
            this.default_content = data.default_content;
            this.group_skip_content = data.group_skip_content;
            this.courier = data.courier;
            this.is_occasional = data.is_occasional;
            this.fixed_sender_address = data.fixed_sender_address;
            this.can_view_price = data.can_view_price;
            this.has_pickups = data.has_pickups;
            this.initial_pickup_status = data.initial_pickup_status;
            this.awb_series = data.awb_series;
            this.preprinted_awb_series = data.preprinted_awb_series;
            this.retur_awb_series = data.retur_awb_series;
            this.hub = data.hub;
            this.skip_courier_comission = data.skip_courier_comission;
            this.skip_km_on_courier_comission = data.skip_km_on_courier_comission;
            this.awb_event_handler = data.awb_event_handler;
            this.initial_api_status = data.initial_api_status;
            this.initial_import_status = data.initial_import_status;
            this.block_reweights = data.block_reweights;
            this.reweigh_percentage = data.reweigh_percentage;
            this.supplies_discount_percent = data.supplies_discount_percent;
            this.mandatory_hub = data.mandatory_hub;
            this.late_retur_criteria = data.late_retur_criteria;
            this.switch_with_retur = data.switch_with_retur;
            this.replacement_swap = data.replacement_swap;
            this.expeditions_can_be_paid_by_card = data.expeditions_can_be_paid_by_card;
            this.remove_f_number_from_all_awbs = data.remove_f_number_from_all_awbs;
            this.static_batch_returs = data.static_batch_returs;
            this.do_not_invoice = data.do_not_invoice;
            this.max_address_character_size = data.max_address_character_size;
            this.show_test_watermark_on_label = data.show_test_watermark_on_label;
            this.reference_on_return_label = data.reference_on_return_label;
            this.customer_reference_prefix = data.customer_reference_prefix;
            this.retur_flow_type = data.retur_flow_type;
            this.show_reweight_events_in_history = data.show_reweight_events_in_history;
            this.hide_phone_at_print = data.hide_phone_at_print;
            this.hide_phone_at_print_for_franchisors = data.hide_phone_at_print_for_franchisors;
            this.anonimize_awb_details_after_days = data.anonimize_awb_details_after_days;
            this.volumetric_weight_constant = data.volumetric_weight_constant;
            this.custom_annex_template = data.custom_annex_template;
            this.custom_cod_annex_template = data.custom_cod_annex_template;
            this.custom_cod_annex_starting_no = data.custom_cod_annex_starting_no;
            this.weight_price_rounding = data.weight_price_rounding;
            this.ramburs_type = data.ramburs_type;
            this.force_ramburs_type = data.force_ramburs_type;
            this.force_cod_only = data.force_cod_only;
            this.allowed_ramburs_types = data.allowed_ramburs_types;
            this.block_client_deconts = data.block_client_deconts;
            this.hide_ramburs_receipt = data.hide_ramburs_receipt;
            this.date_on_cod_receipt = data.date_on_cod_receipt;
            this.tax_ramburs_on_returned = data.tax_ramburs_on_returned;
            this.email_decont = data.email_decont;
            this.cod_report_enabled = data.cod_report_enabled;
            this.cod_report_email = data.cod_report_email;
            this.substract_price_from_client_decont = data.substract_price_from_client_decont;
            this.cod_decont_delay_days = data.cod_decont_delay_days;
            this.auto_add_existing_invoices = data.auto_add_existing_invoices;
            this.default_payer = data.default_payer;
            this.cash_invoice_client = data.cash_invoice_client;
            this.invoice_description = data.invoice_description;
            this.strongo_currency = data.strongo_currency;
            this.tva_percent = data.tva_percent;
            this.invoice_reminders = data.invoice_reminders;
            this.penalty = data.penalty;
            this.cash_only = data.cash_only;
            this.hide_sender_payer = data.hide_sender_payer;
            this.auto_invoice = data.auto_invoice;
            this.invoice_delay_days = data.invoice_delay_days;
            this.invoice_group = data.invoice_group;
            this.invoice_grouped_by_address = data.invoice_grouped_by_address;
            this.can_pay_to_courier = data.can_pay_to_courier;
            this.max_pay_to_courier = data.max_pay_to_courier;
            this.invoice_uncollected_expeditions = data.invoice_uncollected_expeditions;
            this.invoice_active_and_notified = data.invoice_active_and_notified;
            this.invoice_exception_shipments = data.invoice_exception_shipments;
            this.skip_auto_lock = data.skip_auto_lock;
            this.days_until_blocking = data.days_until_blocking;
            this.min_priced_insurance = data.min_priced_insurance;
            this.discount_percent = data.discount_percent;
            this.use_credits = data.use_credits;
            this.credit_price = data.credit_price;
            this.price_only_destination_km = data.price_only_destination_km;
            this.ignore_volumetric_weight = data.ignore_volumetric_weight;
            this.kg_included_per_retur = data.kg_included_per_retur;
            this.strongo_contact = data.strongo_contact;
            this.support_email = data.support_email;
            this.delivery_email = data.delivery_email;
            this.use_cod_information = data.use_cod_information;
            this.cod_name = data.cod_name;
            this.cod_phone = data.cod_phone;
            this.cod_address = data.cod_address;
            this.cod_city = data.cod_city;
            this.cod_county = data.cod_county;
            this.cod_zipcode = data.cod_zipcode;
            this.cod_country = data.cod_country;
            this.cod_regcom = data.cod_regcom;
            this.cod_cui = data.cod_cui;
            this.from_contact = data.from_contact;
            this.from_address = data.from_address;
            this.from_sector = data.from_sector;
            this.from_zipcode = data.from_zipcode;
            this.from_country = data.from_country;
            this.from_county = data.from_county;
            this.from_city = data.from_city;
            this.from_phone = data.from_phone;
            this.fixed_cod_retur_address = data.fixed_cod_retur_address;
            this.cod_retur_address = data.cod_retur_address;
            this.cod_retur_zipcode = data.cod_retur_zipcode;
            this.cod_retur_city = data.cod_retur_city;
            this.cod_retur_county = data.cod_retur_county;
            this.cod_retur_country = data.cod_retur_country;
            this.cod_retur_phone = data.cod_retur_phone;
            this.fixed_retur_address = data.fixed_retur_address;
            this.retur_address = data.retur_address;
            this.retur_zipcode = data.retur_zipcode;
            this.retur_city = data.retur_city;
            this.retur_county = data.retur_county;
            this.retur_country = data.retur_country;
            this.retur_phone = data.retur_phone;
        }
    }

    serializeData(): CompanyStrongoSettingData {
        const serialized_data: CompanyStrongoSettingData = {
            id: this.id,
            company_id: this.company_id,
            is_client: this.is_client,
            is_validated: this.is_validated,
            is_lead: this.is_lead,
            client_type: this.client_type,
            min_shipments: this.min_shipments,
            max_shipments: this.max_shipments,
            franchisor_id: this.franchisor_id,
            franchisor_location_id: this.franchisor_location_id,
            delivery_sms: this.delivery_sms,
            sms_name: this.sms_name,
            confirmation_codes_active: this.confirmation_codes_active,
            awb_print_count: this.awb_print_count,
            several_print_count: this.several_print_count,
            can_print_a6: this.can_print_a6,
            mixed_group_print: this.mixed_group_print,
            print_separator: this.print_separator,
            show_customer_reference_barcode_on_print: this.show_customer_reference_barcode_on_print,
            hide_sender_address: this.hide_sender_address,
            label_text: this.label_text,
            default_content: this.default_content,
            group_skip_content: this.group_skip_content,
            courier: this.courier,
            is_occasional: this.is_occasional,
            fixed_sender_address: this.fixed_sender_address,
            can_view_price: this.can_view_price,
            has_pickups: this.has_pickups,
            initial_pickup_status: this.initial_pickup_status,
            awb_series: this.awb_series,
            preprinted_awb_series: this.preprinted_awb_series,
            retur_awb_series: this.retur_awb_series,
            hub: this.hub,
            skip_courier_comission: this.skip_courier_comission,
            skip_km_on_courier_comission: this.skip_km_on_courier_comission,
            awb_event_handler: this.awb_event_handler,
            initial_api_status: this.initial_api_status,
            initial_import_status: this.initial_import_status,
            block_reweights: this.block_reweights,
            reweigh_percentage: this.reweigh_percentage,
            supplies_discount_percent: this.supplies_discount_percent,
            mandatory_hub: this.mandatory_hub,
            late_retur_criteria: this.late_retur_criteria,
            switch_with_retur: this.switch_with_retur,
            replacement_swap: this.replacement_swap,
            expeditions_can_be_paid_by_card: this.expeditions_can_be_paid_by_card,
            remove_f_number_from_all_awbs: this.remove_f_number_from_all_awbs,
            static_batch_returs: this.static_batch_returs,
            do_not_invoice: this.do_not_invoice,
            max_address_character_size: this.max_address_character_size,
            show_test_watermark_on_label: this.show_test_watermark_on_label,
            reference_on_return_label: this.reference_on_return_label,
            customer_reference_prefix: this.customer_reference_prefix,
            retur_flow_type: this.retur_flow_type,
            show_reweight_events_in_history: this.show_reweight_events_in_history,
            hide_phone_at_print: this.hide_phone_at_print,
            hide_phone_at_print_for_franchisors: this.hide_phone_at_print_for_franchisors,
            anonimize_awb_details_after_days: this.anonimize_awb_details_after_days,
            volumetric_weight_constant: this.volumetric_weight_constant,
            custom_annex_template: this.custom_annex_template,
            custom_cod_annex_template: this.custom_cod_annex_template,
            custom_cod_annex_starting_no: this.custom_cod_annex_starting_no,
            weight_price_rounding: this.weight_price_rounding,
            ramburs_type: this.ramburs_type,
            force_ramburs_type: this.force_ramburs_type,
            force_cod_only: this.force_cod_only,
            allowed_ramburs_types: this.allowed_ramburs_types,
            block_client_deconts: this.block_client_deconts,
            hide_ramburs_receipt: this.hide_ramburs_receipt,
            date_on_cod_receipt: this.date_on_cod_receipt,
            tax_ramburs_on_returned: this.tax_ramburs_on_returned,
            email_decont: this.email_decont,
            cod_report_enabled: this.cod_report_enabled,
            cod_report_email: this.cod_report_email,
            substract_price_from_client_decont: this.substract_price_from_client_decont,
            cod_decont_delay_days: this.cod_decont_delay_days,
            auto_add_existing_invoices: this.auto_add_existing_invoices,
            default_payer: this.default_payer,
            cash_invoice_client: this.cash_invoice_client,
            invoice_description: this.invoice_description,
            strongo_currency: this.strongo_currency,
            tva_percent: this.tva_percent,
            invoice_reminders: this.invoice_reminders,
            penalty: this.penalty,
            cash_only: this.cash_only,
            hide_sender_payer: this.hide_sender_payer,
            auto_invoice: this.auto_invoice,
            invoice_delay_days: this.invoice_delay_days,
            invoice_group: this.invoice_group,
            invoice_grouped_by_address: this.invoice_grouped_by_address,
            can_pay_to_courier: this.can_pay_to_courier,
            max_pay_to_courier: this.max_pay_to_courier,
            invoice_uncollected_expeditions: this.invoice_uncollected_expeditions,
            invoice_active_and_notified: this.invoice_active_and_notified,
            invoice_exception_shipments: this.invoice_exception_shipments,
            skip_auto_lock: this.skip_auto_lock,
            days_until_blocking: this.days_until_blocking,
            min_priced_insurance: this.min_priced_insurance,
            discount_percent: this.discount_percent,
            use_credits: this.use_credits,
            credit_price: this.credit_price,
            price_only_destination_km: this.price_only_destination_km,
            ignore_volumetric_weight: this.ignore_volumetric_weight,
            kg_included_per_retur: this.kg_included_per_retur,
            strongo_contact: this.strongo_contact,
            support_email: this.support_email,
            delivery_email: this.delivery_email,
            use_cod_information: this.use_cod_information,
            cod_name: this.cod_name,
            cod_phone: this.cod_phone,
            cod_address: this.cod_address,
            cod_city: this.cod_city,
            cod_county: this.cod_county,
            cod_zipcode: this.cod_zipcode,
            cod_country: this.cod_country,
            cod_regcom: this.cod_regcom,
            cod_cui: this.cod_cui,
            from_contact: this.from_contact,
            from_address: this.from_address,
            from_sector: this.from_sector,
            from_zipcode: this.from_zipcode,
            from_country: this.from_country,
            from_county: this.from_county,
            from_city: this.from_city,
            from_phone: this.from_phone,
            fixed_cod_retur_address: this.fixed_cod_retur_address,
            cod_retur_address: this.cod_retur_address,
            cod_retur_zipcode: this.cod_retur_zipcode,
            cod_retur_city: this.cod_retur_city,
            cod_retur_county: this.cod_retur_county,
            cod_retur_country: this.cod_retur_country,
            cod_retur_phone: this.cod_retur_phone,
            fixed_retur_address: this.fixed_retur_address,
            retur_address: this.retur_address,
            retur_zipcode: this.retur_zipcode,
            retur_city: this.retur_city,
            retur_county: this.retur_county,
            retur_country: this.retur_country,
            retur_phone: this.retur_phone,
        };

        return serialized_data;
    }
}

export type CompanyStrongoSettingData = {
    id: number | null;
    company_id: number | null;
    is_client: number;
    is_validated: number;
    is_lead: number;
    client_type: number | null;
    min_shipments: number;
    max_shipments: number;
    franchisor_id: string | null;
    franchisor_location_id: string | null;
    delivery_sms: number;
    sms_name: string;
    confirmation_codes_active: number;
    awb_print_count: number;
    several_print_count: number;
    can_print_a6: number;
    mixed_group_print: number;
    print_separator: string;
    show_customer_reference_barcode_on_print: string | null;
    hide_sender_address: number;
    label_text: string | null;
    default_content: string | null;
    group_skip_content: number;
    courier: number;
    is_occasional: number;
    fixed_sender_address: number;
    can_view_price: number;
    has_pickups: number;
    initial_pickup_status: string;
    awb_series: number;
    preprinted_awb_series: number;
    retur_awb_series: number;
    hub: number;
    skip_courier_comission: number;
    skip_km_on_courier_comission: number;
    awb_event_handler: string | null;
    initial_api_status: string;
    initial_import_status: string;
    block_reweights: number;
    reweigh_percentage: number;
    supplies_discount_percent: number;
    mandatory_hub: string | null;
    late_retur_criteria: string | null;
    switch_with_retur: number;
    replacement_swap: number;
    expeditions_can_be_paid_by_card: number;
    remove_f_number_from_all_awbs: number;
    static_batch_returs: number;
    do_not_invoice: number;
    max_address_character_size: number;
    show_test_watermark_on_label: number;
    reference_on_return_label: number;
    customer_reference_prefix: string | null;
    retur_flow_type: string;
    show_reweight_events_in_history: string;
    hide_phone_at_print: number;
    hide_phone_at_print_for_franchisors: string | null;
    anonimize_awb_details_after_days: number;
    volumetric_weight_constant: number;
    custom_annex_template: string | null;
    custom_cod_annex_template: string | null;
    custom_cod_annex_starting_no: number;
    weight_price_rounding: string | null;
    ramburs_type: string;
    force_ramburs_type: number;
    force_cod_only: number;
    allowed_ramburs_types: string;
    block_client_deconts: number;
    hide_ramburs_receipt: number;
    date_on_cod_receipt: number;
    tax_ramburs_on_returned: number;
    email_decont: string | null;
    cod_report_enabled: number;
    cod_report_email: string | null;
    substract_price_from_client_decont: number;
    cod_decont_delay_days: number;
    auto_add_existing_invoices: number;
    default_payer: string | null;
    cash_invoice_client: number;
    invoice_description: string | null;
    strongo_currency: string | null;
    tva_percent: number | null;
    invoice_reminders: number;
    penalty: number;
    cash_only: number;
    hide_sender_payer: number;
    auto_invoice: number;
    invoice_delay_days: number;
    invoice_group: string | null;
    invoice_grouped_by_address: number;
    can_pay_to_courier: number;
    max_pay_to_courier: number;
    invoice_uncollected_expeditions: string | null;
    invoice_active_and_notified: string | null;
    invoice_exception_shipments: string | null;
    skip_auto_lock: number;
    days_until_blocking: number;
    min_priced_insurance: number;
    discount_percent: number;
    use_credits: number;
    credit_price: number;
    price_only_destination_km: number;
    ignore_volumetric_weight: number;
    kg_included_per_retur: number;
    strongo_contact: string | null;
    support_email: string | null;
    delivery_email: string | null;
    use_cod_information: number;
    cod_name: string | null;
    cod_phone: string | null;
    cod_address: string | null;
    cod_city: string | null;
    cod_county: string | null;
    cod_zipcode: string | null;
    cod_country: number | null;
    cod_regcom: string | null;
    cod_cui: string | null;
    from_contact: string | null;
    from_address: string | null;
    from_sector: string | null;
    from_zipcode: string | null;
    from_country: number | null;
    from_county: string | null;
    from_city: string | null;
    from_phone: string | null;
    fixed_cod_retur_address: number;
    cod_retur_address: string | null;
    cod_retur_zipcode: string | null;
    cod_retur_city: string | null;
    cod_retur_county: string | null;
    cod_retur_country: number | null;
    cod_retur_phone: string | null;
    fixed_retur_address: number;
    retur_address: string | null;
    retur_zipcode: string | null;
    retur_city: string | null;
    retur_county: string | null;
    retur_country: number | null;
    retur_phone: string | null;
};
